import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/app";
import "./styles/globals.css";
import { initObservability } from "./lib/observability";
import { registerServiceWorker } from "./pwa/register-sw";

initObservability();

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

registerServiceWorker();
